import { REMOVED_DESTINATION_MARKETPLACE_CODES } from '@/types/auction';

const removedDestinationMarketplaceCodes = new Set<string>(REMOVED_DESTINATION_MARKETPLACE_CODES);

export const omitRemovedDestinationMarketplaces = <T extends string>(codes: readonly T[]): T[] =>
    codes.filter((code) => !removedDestinationMarketplaceCodes.has(code));
